import React from "react";
import { BrowserRouter, HashRouter } from "react-router-dom";
import AppProviders from "./hooks/providers/AppProviders";
import AppContent from "./AppContent";
import "./styles/app.css";

const App: React.FC = () => {
  const isElectron = (() => {
    // window.process may be unavailable with contextIsolation
    const ua =
      typeof navigator !== "undefined" && navigator.userAgent
        ? navigator.userAgent.toLowerCase()
        : "";
    return (
      ua.includes("electron") ||
      Boolean((window as any)?.process?.versions?.electron)
    );
  })();
  const RouterComponent = isElectron ? HashRouter : BrowserRouter;
  return (
    <RouterComponent>
      <AppProviders>
        <AppContent />
      </AppProviders>
    </RouterComponent>
  );
};

export default App;
